import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserCart, saveAddress, saveOrder, emptyCart, getUserProfile } from "../function/users";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spin } from "antd";
import FileUpload from "./FileUpload";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import Swal from "sweetalert2";
import "./CheckOut.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const CheckOut = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [total, setTotal] = useState(0);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [addressSaved, setAddressSaved] = useState(false);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const [provinces, setProvinces] = useState([]);
  const [amphures, setAmphures] = useState([]);
  const [tambons, setTambons] = useState([]);

  const [paymentMethod, setPaymentMethod] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponValid, setCouponValid] = useState(false);
  const [pointsUsed, setPointsUsed] = useState(0);

  const [selected, setSelected] = useState({ province: "", amphure: "", tambon: "", zip_code: "" });
  const [extractedText, setExtractedText] = useState("");
  const [points, setPoints] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState(0);
  const [deliveryMethod, setDeliveryMethod] = useState("homeDelivery");
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");

  useEffect(() => {
    if (user && user.token) {
      getUserProfile(user.token)
        .then((res) => {
          if (res.data && res.data.address) {
            const addr = res.data.address;
            setName(addr.name || "");
            setPhone(addr.phone || "");
            setEmail(addr.email || "");
            setAddress(addr.address || "");
          }
          setPoints(res.data.points || 0);
        })
        .catch((err) => console.error("Error fetching user profile:", err));
      loadBranches();
    }
  }, [user]);

  const loadBranches = async () => {
    try {
      const { data } = await axios.get(process.env.REACT_APP_API + "/branch", {
        headers: { authtoken: user.token },
      });
      setBranches(data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    if (user && user.token) {
      getUserCart(user.token)
        .then((res) => {
          setProducts(
            res.data.products.map((item) => {
              let productData = item.product || item.productservice || item.productmenu;
              if (item.productmenu) {
                productData = item.productmenu.categoryMenu.subCategories.products.find(
                  (p) => p._id.toString() === item.productmenu.toString()
                );
              }
              return {
                ...item,
                title: productData ? productData.title : "Unknown",
                price: item.discountedPrice || (productData ? productData.price : 0),
              };
            })
          );
          setTotal(res.data.cartTotal);
        })
        .catch((err) => console.error("Error fetching cart:", err));
    }
    fetch("https://raw.githubusercontent.com/kongvut/thai-province-data/master/api_province_with_amphure_tambon.json")
      .then((r) => r.json())
      .then((result) => setProvinces(result));
  }, [user.token]);

  const DropdownList = ({ label, id, list, child, childsId = [], setChilds = [] }) => {
    const onChangeHandle = (event) => {
      setChilds.forEach((setChild) => setChild([]));
      const entries = childsId.map((c) => [c, ""]);
      const unSelectChilds = Object.fromEntries(entries);
      const input = event.target.value;
      const selectedItem = list.find((item) => item.name_th === input);
      setSelected((prev) => ({
        ...prev,
        ...unSelectChilds,
        [id]: selectedItem ? selectedItem.name_th : "",
        zip_code: selectedItem && selectedItem.zip_code ? selectedItem.zip_code : "",
      }));
      if (!selectedItem) return;
      if (child) {
        const { [child]: childs } = selectedItem;
        const [setChild] = setChilds;
        setChild(childs);
      }
    };
    return (
      <div className="co-field">
        <label className="co-label">{label}</label>
        <select value={selected[id]} onChange={onChangeHandle} className="co-select">
          <option value="">เลือก...</option>
          {list.map((item) => (
            <option key={item.id} value={item.name_th}>
              {item.name_th}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleApplyPoints = () => {
    const maxDiscountBaht = Math.floor(total * 0.2);
    const maxPointsUsable = Math.min(points, maxDiscountBaht * 100);
    const discountFromPoints = Math.floor(maxPointsUsable / 100);
    setDiscount(discountFromPoints);
    setPointsUsed(discountFromPoints * 100);
  };

  const handleSaveAddress = async () => {
    if (!name || !phone || !address || !email || !selected.province || !selected.amphure || !selected.tambon) {
      return false;
    }
    const fullAddress = `${address} ${selected.province}, ${selected.amphure}, ${selected.tambon}, ${selected.zip_code}`;
    const addressData = { name, phone, address: fullAddress, email };
    try {
      const res = await saveAddress(user.token, addressData);
      if (res.data?.ok) {
        await Swal.fire({ title: "บันทึกที่อยู่สำเร็จ", icon: "success", confirmButtonText: "ตกลง", confirmButtonColor: "#1D9E75" });
        setAddressSaved(true);
        return true;
      }
    } catch (err) {
      console.error("Error saving address:", err);
      await Swal.fire({ title: "เกิดข้อผิดพลาด", text: "ไม่สามารถบันทึกที่อยู่ได้", icon: "error", confirmButtonText: "ตกลง" });
      return false;
    }
  };

  const handleCreateOrder = async () => {
    setLoading(true);
    if (!name || !phone || !address) {
      await Swal.fire({ title: "ข้อมูลไม่ครบถ้วน", text: "กรุณากรอกข้อมูลที่อยู่ให้ครบ", icon: "warning", confirmButtonText: "ตกลง" });
      setLoading(false);
      return;
    }
    if (!paymentMethod) {
      await Swal.fire({ title: "ยังไม่ได้เลือกวิธีชำระเงิน", text: "กรุณาเลือกวิธีการชำระเงิน", icon: "warning", confirmButtonText: "ตกลง" });
      setLoading(false);
      return;
    }
    await handleSaveAddress();
    const couponDiscountAmount = (total * couponDiscount) / 100;
    const finalTotal = total - discount - couponDiscountAmount;

    if (paymentMethod === "cod") {
      saveOrder(user.token, images, paymentMethod, finalTotal, discount, pointsUsed, invoiceNumber, couponCode, couponDiscount, deliveryMethod, selectedBranch)
        .then((res) => {
          if (res?.data) {
            emptyCart(user.token);
            dispatch({ type: "ADD_TO_CART", payload: [] });
            if (typeof window !== "undefined") localStorage.removeItem("cart");
            toast.success("บันทึกคำสั่งซื้อสำเร็จ");
            navigate("/user/order-tracking");
          } else {
            toast.error("บันทึกคำสั่งซื้อล้มเหลว");
          }
        })
        .catch(() => toast.error("บันทึกคำสั่งซื้อล้มเหลว"))
        .finally(() => setLoading(false));
    } else if (paymentMethod === "card" || paymentMethod === "promptpay") {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API}/create-checkout-session`, {
          cart: products, userId: user._id, couponCode, couponDiscount, paymentMethod, finalTotal, pointsUsed, deliveryMethod, selectedBranch, branchName: selectedBranch,
        });
        const stripe = await stripePromise;
        const result = await stripe.redirectToCheckout({ sessionId: data.sessionId });
        if (result.error) toast.error(result.error.message);
      } catch (error) {
        toast.error("ไม่สามารถเข้าสู่หน้าชำระเงิน Stripe ได้");
      }
    } else {
      saveOrder(user.token, images, paymentMethod, extractedText, discount, pointsUsed, invoiceNumber, couponCode, couponDiscount, deliveryMethod, selectedBranch)
        .then((res) => {
          if (res?.data) {
            emptyCart(user.token);
            dispatch({ type: "ADD_TO_CART", payload: [] });
            if (typeof window !== "undefined") localStorage.removeItem("cart");
            toast.success("บันทึกคำสั่งซื้อสำเร็จ");
            navigate("/user/order-tracking");
          } else {
            toast.error("บันทึกคำสั่งซื้อล้มเหลว");
          }
        })
        .catch(() => toast.error("บันทึกคำสั่งซื้อล้มเหลว"))
        .finally(() => setLoading(false));
    }
  };

  const checkCoupon = async () => {
    if (!couponCode) { toast.error("กรุณากรอกโค้ดคูปอง"); return; }
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API}/check-coupon`, { couponCode, cartTotal: total });
      if (data.valid) {
        setCouponDiscount(data.discount);
        setCouponValid(true);
        toast.success(`ใช้โค้ดสำเร็จ รับส่วนลด ${data.discount}%`);
      } else {
        setCouponDiscount(0);
        setCouponValid(false);
        toast.error(data.message || "โค้ดไม่ถูกต้องหรือหมดอายุ");
      }
    } catch (err) {
      toast.error("เกิดข้อผิดพลาดในการตรวจสอบคูปอง");
    }
  };

  const formatTHB = (val) =>
    new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(val);

  const finalTotal = (() => {
    const v = Math.floor((total - discount - (total * couponDiscount) / 100) * 100) / 100;
    return v;
  })();

  const paymentOptions = [
    { value: "bankTransfer", label: "โอนผ่านธนาคาร", icon: "🏦" },
    { value: "card", label: "บัตรเครดิต", icon: "💳" },
    { value: "promptpay", label: "PromptPay (Stripe)", icon: "📱" },
    { value: "cod", label: "ชำระปลายทาง", icon: "🚚" },
  ];

  return (
    <div className="co-page">
      <div className="co-container">

        {/* ===== LEFT: Address ===== */}
        <div className="co-card">
          <div className="co-card-header">
            <span className="co-card-icon" style={{ background: "#FBEAF0", color: "#D4537E" }}>📍</span>
            <h5 className="co-card-title">ที่อยู่จัดส่ง</h5>
          </div>
          <hr className="co-divider" />

          {!isEditing ? (
            <div className="co-address-view">
              <div className="co-info-row"><span className="co-info-label">ชื่อ</span><span className="co-info-value">{name || "—"}</span></div>
              <div className="co-info-row"><span className="co-info-label">เบอร์โทร</span><span className="co-info-value">{phone || "—"}</span></div>
              <div className="co-info-row"><span className="co-info-label">ที่อยู่</span><span className="co-info-value">{address || "—"}</span></div>
              <div className="co-info-row"><span className="co-info-label">อีเมล</span><span className="co-info-value">{email || "—"}</span></div>
              <button
                className="co-btn-secondary"
                onClick={() => {
                  setAddress(""); setEmail("");
                  setSelected({ province: "", amphure: "", tambon: "", zip_code: "" });
                  setIsEditing(true);
                }}
              >
                ✏️ {name && phone && address && email ? "แก้ไขที่อยู่" : "เพิ่มที่อยู่"}
              </button>
            </div>
          ) : (
            <div className="co-form">
              <div className="co-field">
                <label className="co-label">ชื่อ-นามสกุล</label>
                <input className="co-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="กรอกชื่อ-นามสกุล" />
              </div>
              <div className="co-field">
                <label className="co-label">เบอร์โทรศัพท์</label>
                <input className="co-input" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="กรอกเบอร์โทร" />
              </div>
              <div className="co-field">
                <label className="co-label">ที่อยู่</label>
                <input className="co-input" type="text" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="บ้านเลขที่ / ถนน / ซอย" />
              </div>
              <DropdownList label="จังหวัด" id="province" list={provinces} child="amphure" childsId={["amphure", "tambon"]} setChilds={[setAmphures, setTambons]} />
              <DropdownList label="อำเภอ / เขต" id="amphure" list={amphures} child="tambon" childsId={["tambon"]} setChilds={[setTambons]} />
              <DropdownList label="ตำบล / แขวง" id="tambon" list={tambons} />
              <div className="co-field">
                <label className="co-label">รหัสไปรษณีย์</label>
                <input className="co-input" type="text" value={selected.zip_code} readOnly placeholder="—" />
              </div>
              <div className="co-field">
                <label className="co-label">อีเมล</label>
                <input className="co-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="กรอกอีเมล" />
              </div>
              <div className="co-btn-row">
                <button
                  className="co-btn-green"
                  onClick={() => { handleSaveAddress(); setIsEditing(false); }}
                >
                  ✓ บันทึกที่อยู่
                </button>
                <button className="co-btn-secondary" onClick={() => setIsEditing(false)}>
                  ยกเลิก
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ===== RIGHT: Order Summary ===== */}
        <div className="co-card">
          <div className="co-card-header">
            <span className="co-card-icon" style={{ background: "#E1F5EE", color: "#0F6E56" }}>🛍️</span>
            <h5 className="co-card-title">สรุปคำสั่งซื้อ</h5>
            <span className="co-badge-teal">{products.length} รายการ</span>
          </div>
          <hr className="co-divider" />

          {/* Product list */}
          <ul className="co-product-list">
            {products.map((item, i) => (
              <li key={i} className="co-product-row">
                <span className="co-product-name">
                  {item.product ? item.product.title : "Unknown"} ×{item.count}
                </span>
                <span className="co-product-price">{formatTHB(item.price * item.count)}</span>
              </li>
            ))}
          </ul>
          <hr className="co-divider" />

          {/* Points */}
          <div className="co-points-row">
            <span className="co-label">คะแนนสะสม: <b>{points} แต้ม</b></span>
            <button
              className="co-btn-outline-blue"
              onClick={handleApplyPoints}
              disabled={points < 100 || discount > 0 || couponValid}
            >
              ใช้คะแนน
            </button>
          </div>
          {discount > 0 && (
            <p className="co-discount-note">ส่วนลดจากแต้ม: <b style={{ color: "#D4537E" }}>-{formatTHB(discount)}</b></p>
          )}

          {/* Coupon */}
          <div className="co-field">
            <label className="co-label">โค้ดส่วนลด</label>
            <div className="co-coupon-row">
              <input
                className="co-input"
                type="text"
                placeholder="กรอกโค้ดส่วนลด"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value.trim().toUpperCase())}
                disabled={couponValid || discount > 0}
              />
              <button className="co-btn-blue" onClick={checkCoupon} disabled={couponValid || discount > 0}>
                ใช้โค้ด
              </button>
            </div>
            {couponValid && (
              <p className="co-success-note">
                ✓ ใช้โค้ดสำเร็จ: ลด {couponDiscount}% (-{formatTHB(Math.round(total * couponDiscount / 100))})
              </p>
            )}
          </div>

          {/* Total */}
          <div className="co-total-section">
            <div className="co-total-row"><span>ยอดรวม</span><span>{formatTHB(total)}</span></div>
            {discount > 0 && <div className="co-total-row discount"><span>ส่วนลดแต้ม</span><span>-{formatTHB(discount)}</span></div>}
            {couponValid && <div className="co-total-row discount"><span>ส่วนลดโค้ด</span><span>-{formatTHB(Math.round(total * couponDiscount / 100))}</span></div>}
            <div className="co-total-row final"><span>ยอดสุทธิ</span><span className="co-final-price">{formatTHB(finalTotal)}</span></div>
          </div>

          <hr className="co-divider" />

          {/* Invoice */}
          <div className="co-field">
            <label className="co-label">เลขใบกำกับภาษี (ถ้ามี)</label>
            <input
              className="co-input"
              type="text"
              placeholder="กรอกเลขใบกำกับภาษี"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
          </div>

          {/* Delivery */}
          <div className="co-field">
            <label className="co-label">วิธีรับสินค้า</label>
            <select className="co-select" value={deliveryMethod} onChange={(e) => setDeliveryMethod(e.target.value)}>
              <option value="homeDelivery">จัดส่งถึงบ้าน</option>
              <option value="branchPickup">รับที่สาขา</option>
            </select>
          </div>

          {deliveryMethod === "branchPickup" && (
            <div className="co-field">
              <label className="co-label">เลือกสาขา</label>
              <select className="co-select" value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
                <option value="">-- กรุณาเลือกสาขา --</option>
                {branches.map((b) => (
                  <option key={b._id} value={b.name}>{b.name}</option>
                ))}
              </select>
            </div>
          )}

          <hr className="co-divider" />

          {/* Payment */}
          <div className="co-field">
            <label className="co-label">วิธีชำระเงิน</label>
            <div className="co-payment-grid">
              {paymentOptions.map((opt) => (
                <div
                  key={opt.value}
                  className={`co-payment-option ${paymentMethod === opt.value ? "active" : ""}`}
                  onClick={() => setPaymentMethod(opt.value)}
                >
                  <span className="co-pay-dot" />
                  <span className="co-pay-icon">{opt.icon}</span>
                  <span className="co-pay-label">{opt.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Bank transfer slip */}
          {paymentMethod === "bankTransfer" && (
            <div className="co-bank-info">
              <p className="co-bank-title">ข้อมูลบัญชีธนาคาร</p>
              <p>ธนาคารกสิกรไทย : <b>067-3-91773-9</b></p>
              <p>บริษัท พีดี มาร์เก็ตติ้ง อินโนเวท จำกัด</p>
              <hr className="co-divider" />
              <label className="co-label">อัปโหลดสลิปการชำระเงิน</label>
              <FileUpload images={images} setImages={setImages} setExtractedText={setExtractedText} />
            </div>
          )}

          {/* Place Order */}
          <button className="co-btn-place" onClick={handleCreateOrder} disabled={loading}>
            {loading ? <Spin /> : "🔒 ยืนยันคำสั่งซื้อ"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default CheckOut;